import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import "../../../styles/reports/reports.scss";
import {
  setLoadingPage,
  setErrorMessage,
  setHeaderVisible,
} from "../../../reducers/actions";
import { connect } from "react-redux";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import moment from "moment";
import { Button, Modal } from "react-bootstrap";
import GridLoader from "react-spinners/GridLoader";
import Calendar from "react-calendar/dist/umd/Calendar";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import TimeZoneConvert from "../../../utils/timeZoneConvert";
import LocationTable from "./pointTable";
import GroupWarning from "../../commoncomponents/groupWarning";
import Select from "react-select";
import { here_api_key } from "../../../utils/mapapi";

const MAX_POI_ZONE_REPORT_DAYS = 30;
const POI_ZONE_DATE_RANGE_MESSAGE =
  "POI Zone Visits can cover a maximum of 30 days. Please choose a shorter date range.";
const DEFAULT_MAP_CENTER = { lat: -25.2744, lng: 133.7751 };

class PointOfInterest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetPlaceholder: "Select Asset",
      dataPlaceholder: "Select start date",
      calendarSelect: false,
      calendarSelect2: false,
      dataPlaceholder2: "Select end date",
      calendarStartDate: new Date(),
      calendarEndDate: new Date(),
      assetShow: false,
      groupTabHighlight: true,
      assetTabHighlight: false,
      groupTabHeading: true,
      assetTabHeading: true,
      groupCustomerName: "",
      groupGeneralName: "",
      assetCustomerName: "",
      assetGeneralName: "",
      ReportDate: new Date(),
      globalDate: [],
      poiData: [],
      selectedPoiName: "Select POI Zone",
      // POIId: "",
      selectGroupId: "",
      endDate: new Date(),
      calendarShow: false,
      calendarShow2: false,
      groupDetails: [],
      groupId: "",
      AssetList: [],
      assetId: "",
      reportDetails: [],
      assetLoader: true,
      reportLoader: false,
      errorLoader: false,
      POIId: [],
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
      assetSelectionBoolean: false,
      isLoading:false,
      assetLoading:false,
      loadedReportParams: null,
      poiMenuOpen: false,
      showPreviewModal: false,
      previewGeofence: null,
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.previewMenuHoldUntil = 0;
  }
  async componentDidMount() {
    try {
      let GroupList = await axios.post(
        `${apiHost}/api/Notification/AllGroupForNotification`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if(GroupList.status===200)
      {
        this.setState({isLoading:false, groupDetails: GroupList.data  });
      }
      else {
        this.setState({isLoading:true });
      }
      // this.setState({ groupDetails: GroupList.data });
    } catch (e) {
      console.warn("Report request failed");
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    this.disposeMap();
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false, calendarShow2: false });
    }
  }

  getAssets = async () => {
    try {
      let AssetList = await axios.get(
        `${apiHost}/api/Notification/AssetsByGroupId/${this.groupId}?IsReport=true`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if(AssetList.status===200)
      {
        this.setState({assetLoading:false, AssetList: AssetList.data.paggedlist, assetLoader: false,  });
      }
      else {
        this.setState({assetLoading:true });
      }
      // this.setState({
      //   AssetList: AssetList.data.paggedlist,
      //   assetLoader: false,
      // });
    } catch (e) {
      console.warn("Report request failed");
    }
  };

  handleGroupSelection = (selectedGroup) => {
    if (!selectedGroup) {
      this.groupId = "";
      this.customerId = "";
      this.setState({
        groupId: "",
        groupCustomerName: "",
        groupGeneralName: "",
        assetCustomerName: "",
        assetGeneralName: "",
        assetId: "",
        assetPlaceholder: "Select Asset",
        AssetList: [],
        poiData: [],
        POIId: [],
        assetLoader: false,
      });
      return;
    }

    const { customername, groupName, groupId, customerId } = selectedGroup.data;
    this.setState({ assetLoader: true });
    this.groupId = groupId;
    this.customerId = customerId;
    this.setState({
      groupId,
      groupCustomerName: customername,
      groupGeneralName: groupName,
      assetCustomerName: "",
      assetGeneralName: "",
      assetId: "",
      assetPlaceholder: "Select Asset",
      poiData: [],
      POIId: [],
      assetTabHeading: true,
      groupTabHighlight: false,
      assetTabHighlight: true,
      groupTabHeading: false,
    });
    this.getAssets();
  };
  handleAssetSelection = (selectedAsset) => {
    if (!selectedAsset) {
      this.setState({
        assetId: "",
        assetCustomerName: "",
        assetGeneralName: "",
        assetPlaceholder: "Select Asset",
        poiData: [],
        POIId: [],
        assetTabHighlight: false,
        assetTabHeading: true,
      });
      return;
    }

    const { name, customerName, assetId } = selectedAsset.data;
    this.setState({
      assetId,
      assetCustomerName: name,
      assetGeneralName: customerName,
      assetPlaceholder: name,
      // groupTabHighlight:false,
      assetTabHighlight: false,
      assetTabHeading: false,
    }, this.handlePoiDropDownNew);
  };
  toggleGroupTable = () => {
    let assetClosingBoolean = !this.state.groupTabHighlight;
    this.setState({
      groupTabHighlight: !this.state.groupTabHighlight,
    });

    if (assetClosingBoolean) {
      this.setState({
        assetTabHighlight: false,
      });
    }
  };
  toggleAssetTable = () => {
    let groupClosingBoolean = !this.state.assetTabHighlight;

    this.setState({
      assetTabHighlight: !this.state.assetTabHighlight,
    });
    if (groupClosingBoolean) {
      this.setState({
        groupTabHighlight: false,
      });
    }
  };
  truckFunction = () => {
    // alert("truck function clicked");
    this.setState({
      assetShow: !this.state.assetShow,
    });
  };
  calendarFunction = () => {
    this.setState({
      calendarShow: !this.state.calendarShow,
    });
  };
  onChangeDate = (date) => {
    this.setState({
      calendarSelect: true,
      calendarStartDate: date,
      globalDate: date,
      ReportDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow: false,
    });
  };
  isDateRangeOverLimit = () => {
    if (!this.state.calendarSelect || !this.state.calendarSelect2) {
      return false;
    }

    const startDate = moment(this.state.ReportDate, "YYYY-MM-DD");
    const endDate = moment(this.state.endDate, "YYYY-MM-DD");

    return endDate.diff(startDate, "days") > MAX_POI_ZONE_REPORT_DAYS;
  };
  calendarFunction2 = () => {
    if (this.state.globalDate != "") {
      this.setState({
        calendarShow2: !this.state.calendarShow2,
      });
    } else {
      alert("select start date");
    }
  };
  onChangeDate2 = (date) => {
    this.setState({
      calendarSelect2: true,
      calendarEndDate: date,
      endDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder2: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow2: false,
    });
  };
  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };

  getPoiId = (poi) => {
    const value = poi ? poi.id || poi.Id : "";
    return value == null ? "" : String(value);
  };

  getPoiName = (poi) => poi
    ? poi.name || poi.Name || "Unnamed POI Zone"
    : "Unnamed POI Zone";

  getPoiOwnerName = (poi) => poi
    ? poi.createdByUserName || poi.CreatedByUserName || poi.createdByUserId || poi.CreatedByUserId || ""
    : "";

  isPoiPrivate = (poi) => !!(poi && (poi.private || poi.Private));

  handleGroupSelect = (selectedOptions) => {
    const selected = selectedOptions || [];
    if (selected.length > 10) {
      alert("Limit of 10 POI zones reached");
      return;
    }

    const POIArr = selected.map((single) => single.value);
    this.setState({ POIId: POIArr });
  };

  handlePoiMenuClose = () => {
    if (this.state.showPreviewModal || Date.now() < this.previewMenuHoldUntil) {
      this.setState({ poiMenuOpen: true });
      return;
    }

    this.setState({ poiMenuOpen: false });
  };

  openPoiZonePreview = async (option, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.previewMenuHoldUntil = Date.now() + 1200;
    this.disposeMap();
    this.setState({
      poiMenuOpen: true,
      previewGeofence: null,
      showPreviewModal: true,
    });

    try {
      const response = await axios.get(`${apiHost}/api/Report/PrivateGeofence/${option.value}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      this.setState({ previewGeofence: response.data.geofence }, () => {
        setTimeout(this.renderPreviewMap, 150);
      });
    } catch (e) {
      console.warn("Report request failed");
    }
  };

  closePreviewModal = () => {
    this.disposeMap();
    this.setState({
      showPreviewModal: false,
      previewGeofence: null,
      poiMenuOpen: true,
    });
  };

  disposeMap = () => {
    if (this.map) {
      this.map.dispose();
      this.map = null;
      this.mapUi = null;
    }
  };

  addGeofenceShape = (group, selectedGeofence) => {
    if (!selectedGeofence || !window.H) {
      return;
    }

    const color = selectedGeofence.color || "#1f6feb";
    if (selectedGeofence.type === "circle" && selectedGeofence.lat != null && selectedGeofence.lng != null) {
      const circle = new window.H.map.Circle(
        { lat: selectedGeofence.lat, lng: selectedGeofence.lng },
        selectedGeofence.radius || 100,
        { style: { strokeColor: color, lineWidth: 2, fillColor: "rgba(31, 111, 235, 0.18)" } }
      );
      group.addObject(circle);
      return;
    }

    if ((selectedGeofence.type === "polygon" || selectedGeofence.type === "rectangle") && Array.isArray(selectedGeofence.polygon)) {
      const strip = new window.H.geo.LineString();
      let polygonPointCount = 0;
      selectedGeofence.polygon.forEach((point) => {
        if (point && point.lat != null && point.lng != null) {
          strip.pushPoint({ lat: point.lat, lng: point.lng });
          polygonPointCount += 1;
        }
      });
      if (polygonPointCount >= 3) {
        group.addObject(new window.H.map.Polygon(strip, {
          style: { strokeColor: color, lineWidth: 2, fillColor: "rgba(31, 111, 235, 0.18)" },
        }));
      }
    }
  };

  getPreviewFitBounds = (selectedGeofence) => {
    if (!window.H || !selectedGeofence) {
      return null;
    }

    const points = [];
    const addPoint = (lat, lng) => {
      const nextLat = Number(lat);
      const nextLng = Number(lng);
      if (Number.isFinite(nextLat) && Number.isFinite(nextLng)) {
        points.push({ lat: nextLat, lng: nextLng });
      }
    };

    if (selectedGeofence.type === "circle" && selectedGeofence.lat != null && selectedGeofence.lng != null) {
      const centerLat = Number(selectedGeofence.lat);
      const centerLng = Number(selectedGeofence.lng);
      const radiusMeters = Number(selectedGeofence.radius) || 100;
      if (Number.isFinite(centerLat) && Number.isFinite(centerLng)) {
        const latDelta = radiusMeters / 111320;
        const lngDelta = radiusMeters / (111320 * Math.max(Math.cos(centerLat * Math.PI / 180), 0.0001));
        addPoint(centerLat, centerLng);
        addPoint(centerLat + latDelta, centerLng);
        addPoint(centerLat - latDelta, centerLng);
        addPoint(centerLat, centerLng + lngDelta);
        addPoint(centerLat, centerLng - lngDelta);
      }
    } else if ((selectedGeofence.type === "polygon" || selectedGeofence.type === "rectangle") && Array.isArray(selectedGeofence.polygon)) {
      selectedGeofence.polygon.forEach((point) => addPoint(point.lat, point.lng));
    }

    if (!points.length) {
      return null;
    }

    const lats = points.map((point) => point.lat);
    const lngs = points.map((point) => point.lng);
    const top = Math.max(...lats);
    const bottom = Math.min(...lats);
    const left = Math.min(...lngs);
    const right = Math.max(...lngs);
    const latSpan = Math.max(top - bottom, 0.0007);
    const lngSpan = Math.max(right - left, 0.0007);
    const latPadding = Math.max(latSpan * 0.22, 0.00018);
    const lngPadding = Math.max(lngSpan * 0.22, 0.00018);

    return new window.H.geo.Rect(
      Math.min(90, top + latPadding),
      Math.max(-180, left - lngPadding),
      Math.max(-90, bottom - latPadding),
      Math.min(180, right + lngPadding)
    );
  };

  renderPreviewMap = () => {
    const container = document.getElementById("poiZoneVisitPreviewMap");
    const { previewGeofence } = this.state;
    if (!container || !previewGeofence || !window.H) {
      return;
    }

    this.disposeMap();
    container.innerHTML = "";
    const platform = new window.H.service.Platform({ apikey: here_api_key });
    const defaultLayers = platform.createDefaultLayers();
    const map = new window.H.Map(container, defaultLayers.vector.normal.map, {
      center: DEFAULT_MAP_CENTER,
      zoom: 5,
      pixelRatio: window.devicePixelRatio || 1,
    });
    new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(map));
    this.mapUi = window.H.ui.UI.createDefault(map, defaultLayers);
    this.map = map;

    const group = new window.H.map.Group();
    map.addObject(group);
    this.addGeofenceShape(group, previewGeofence);

    const bounds = this.getPreviewFitBounds(previewGeofence) || group.getBoundingBox();
    if (bounds) {
      const fitMap = () => {
        map.getViewPort().resize();
        map.getViewPort().setPadding(30, 42, 42, 42);
        map.getViewModel().setLookAtData({ bounds, tilt: 0 });
      };
      fitMap();
      setTimeout(fitMap, 250);
      setTimeout(fitMap, 700);
    }
  };

  handlePoiDropDownNew = async () => {
    try {
      let poiList = await axios.get(
        `${apiHost}/api/POI/GetAllPOIs?customerId=${this.customerId}`,

        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        poiData: poiList.data,
      });
    } catch (e) {
      console.warn("Report request failed");
    }
  };
  handlePoiDropDown = async () => {
    try {
      let poiList = await axios.get(
        `${apiHost}/api/POI/GetAllByAssetId/${this.state.assetId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        poiData: poiList.data,
      });
    } catch (e) {
      console.warn("Report request failed");
    }
  };
  handleCreateReport = async () => {
    if (this.isDateRangeOverLimit()) {
      return;
    }

    this.setState({
      reportDetails:[],
      assetSelectionBoolean: true,
      reportLoader: true,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
      loadedReportParams: {
        groupId: this.state.groupId,
        assetId: this.state.assetId,
        poiIds: this.state.POIId.join(","),
        reportDate: this.state.ReportDate,
        endDate: this.state.endDate,
      },
    });

    try {
      let ReportDetails = await axios.post(
        `${apiHost}/api/Report/POIReport`,
        {
          AssetId: this.state.assetId,
          SearchDate: this.state.ReportDate,
          Timezone: localStorage.getItem("timeZoneID"),
          UseFiltering: true,
          EndDate: this.state.endDate,
          POIIds: this.state.POIId,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({
        reportLoader: false,
        errorLoader: false,
      });

      this.setState({ reportDetails: ReportDetails.data });
    } catch (e) {
      this.setState({ errorLoader: true, reportLoader: false });
      console.warn("Report request failed");
    }
  };

  render() {
    const selectStyles = {
      control: (base, state) => ({
        ...base,
        minHeight: 44,
        backgroundColor: "#f8fafc",
        borderColor: state.isFocused ? "#244b8f" : "#dbe4ef",
        borderRadius: 8,
        boxShadow: state.isFocused ? "0 0 0 2px rgba(36, 75, 143, 0.14)" : "none",
        "&:hover": {
          borderColor: state.isFocused ? "#244b8f" : "#aebdd0",
        },
      }),
      indicatorSeparator: (base) => ({
        ...base,
        backgroundColor: "#dbe4ef",
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? "#244b8f" : state.isFocused ? "#edf3fb" : "#fff",
        color: state.isSelected ? "#fff" : "#26354f",
        fontSize: 13,
      }),
      placeholder: (base) => ({
        ...base,
        color: "#7e8da1",
      }),
      multiValue: (base) => ({
        ...base,
        backgroundColor: "#edf3fb",
        borderRadius: 999,
      }),
      multiValueLabel: (base) => ({
        ...base,
        color: "#17233c",
        fontWeight: 700,
      }),
      singleValue: (base) => ({
        ...base,
        color: "#17233c",
        fontWeight: 700,
      }),
      menu: (base) => ({
        ...base,
        zIndex: 200,
        borderRadius: 8,
        overflow: "hidden",
      }),
    };

    const formatPoiOptionLabel = (option, meta) => {
      const isPrivate = this.isPoiPrivate(option.data);
      const ownerName = this.getPoiOwnerName(option.data);

      if (meta.context !== "menu") {
        return option.label;
      }

      return (
        <div className="geofence-zone-option">
          <span className="geofence-zone-option-name">{option.label}</span>
          <span className={isPrivate ? "geofence-zone-badge private" : "geofence-zone-badge public"}>
            {isPrivate ? "Private" : "Public"}
          </span>
          {isPrivate && ownerName && (
            <span className="geofence-zone-owner">{ownerName}</span>
          )}
          <button
            aria-label={`Preview ${option.label}`}
            className="geofence-zone-preview-button"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
            }}
            onMouseDown={(event) => this.openPoiZonePreview(option, event)}
            title="Preview POI Zone"
            type="button"
          >
            <i className="fa fa-eye"></i>
          </button>
        </div>
      );
    };

    const groupOptions = this.state.groupDetails.map((group) => ({
      value: group.groupId,
      label: `${group.customername} - ${group.groupName}`,
      data: group,
    }));

    const selectedGroupOption =
      groupOptions.find((option) => option.value == this.state.groupId) || null;

    const assetOptions = this.state.AssetList.map((asset) => ({
      value: asset.assetId,
      label: `${asset.name}${asset.customerName ? ` - ${asset.customerName}` : ""}`,
      data: asset,
    }));

    const selectedAssetOption =
      assetOptions.find((option) => option.value == this.state.assetId) || null;

    const poiOptions = this.state.poiData.map((poi) => ({
      value: this.getPoiId(poi),
      label: this.getPoiName(poi),
      data: poi,
    })).filter((option) => option.value !== "");
    const selectedPoiOptions = poiOptions.filter((option) => this.state.POIId.includes(option.value));

    const isDateRangeOverLimit = this.isDateRangeOverLimit();
    const canCreateReport = !!(
      this.state.assetCustomerName != "" &&
      this.state.POIId.length > 0 &&
      this.state.calendarSelect &&
      this.state.calendarSelect2 &&
      !isDateRangeOverLimit
    );
    const loadedReportParams = this.state.loadedReportParams;
    const hasPendingReportChanges = !!(
      loadedReportParams &&
      canCreateReport &&
      (
        (loadedReportParams.groupId || "") !== (this.state.groupId || "") ||
        loadedReportParams.assetId !== this.state.assetId ||
        loadedReportParams.poiIds !== this.state.POIId.join(",") ||
        loadedReportParams.reportDate !== this.state.ReportDate ||
        loadedReportParams.endDate !== this.state.endDate
      )
    );

    const calendarReport = this.state.calendarShow ? (
      <div
        className="ParentCalender"
        ref={this.setWrapperRef}
        style={{ position: "relative", zIndex: 100 }}
      >
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            maxDate={new Date()}
            //  minDate={moment(this.state.globalDate[0]).subtract(3, 'months').toDate()}
            onChange={this.onChangeDate}
            value={this.state.calendarStartDate}
          />
        </div>
      </div>
    ) : (
      ""
    );
    const calendarReport2 = this.state.calendarShow2 ? (
      <div
        className="ParentCalender"
        ref={this.setWrapperRef}
        style={{ position: "relative", zIndex: 100 }}
      >
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            minDate={this.state.globalDate}
            maxDate={
              moment(this.state.globalDate).add(MAX_POI_ZONE_REPORT_DAYS, "days").toDate() >
              new Date()
                ? new Date()
                : moment(this.state.globalDate).add(MAX_POI_ZONE_REPORT_DAYS, "days").toDate()
            }
            onChange={this.onChangeDate2}
            value={this.state.calendarEndDate}
          />
        </div>
      </div>
    ) : (
      ""
    );
    return (
      <Layout>
        <Helmet>
          <title>POI Zone Visits (Multiple) Report</title>
        </Helmet>
        <div className="contentBody">
          <div
            className={
              !this.props.headerHide
                ? `contentWrapper contentWrapperSmoothRelease report-modern-page poi-report-page`
                : `contentWrapper contentWrapperSmooth report-modern-page poi-report-page`
            }
          >
            <div className="reportHeaderTile">
              <div className="headingContainer report-modern-header">
                <div>
                  <h2 className="mainHeading">POI Zone Visits (Multiple) Report</h2>
                  <p>Review when a selected asset entered and exited customer POI zones within a filtered date range.</p>
                </div>
                <i
                  className={
                    this.props.headerHide
                      ? `fa fa-window-restore`
                      : `fa fa-window-maximize`
                  }
                  onClick={this.handleWindow}
                />
              </div>
              <div className="inputFormGroup reportPickerGrid reportPickerToolbar">
                <div className="inputElement reportPickerField">
                  <label>Group</label>
                  <Select
                    value={selectedGroupOption}
                    options={groupOptions}
                    styles={selectStyles}
                    onChange={this.handleGroupSelection}
                    isClearable
                    isSearchable
                    placeholder="Search group"
                    noOptionsMessage={() => "No groups found"}
                  />
                  {this.state.isLoading && (
                    <GroupWarning
                      warningText={true}
                      warningTextHead="No Groups Found"
                      warningTextBody=" You do not have any group memberships. Please contact Support to ensure your account configured correctly."
                    />
                  )}
                </div>
                <div className="inputElement reportPickerField">
                  <label>Asset</label>
                  <Select
                    value={selectedAssetOption}
                    options={assetOptions}
                    styles={selectStyles}
                    onChange={this.handleAssetSelection}
                    isClearable
                    isSearchable
                    isDisabled={!this.state.groupId && !this.state.assetId}
                    isLoading={this.state.assetLoader && this.state.groupId != ""}
                    placeholder={this.state.groupId ? "Search asset" : "Select group first"}
                    noOptionsMessage={() => "No assets found"}
                  />
                </div>
                <div className="inputElement reportPickerField poiPickerField">
                  <label>POI Zone</label>
                  <Select
                    value={selectedPoiOptions}
                    options={poiOptions}
                    styles={selectStyles}
                    formatOptionLabel={formatPoiOptionLabel}
                    onChange={this.handleGroupSelect}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    menuIsOpen={this.state.poiMenuOpen}
                    onMenuOpen={() => this.setState({ poiMenuOpen: true })}
                    onMenuClose={this.handlePoiMenuClose}
                    isSearchable
                    isDisabled={!this.state.assetId}
                    placeholder={this.state.assetId ? "Search POI zones" : "Select asset first"}
                    noOptionsMessage={() => "No POI Zones found for this customer"}
                  />
                </div>
                <div className="inputElement reportPickerField">
                  <label>Start date</label>
                  <ReportButtonGroup
                    function={this.calendarFunction}
                    dropDown={calendarReport}
                    placeholder={this.state.dataPlaceholder}
                    icon="fa-calendar"
                  />
                </div>
                <div className="inputElement reportPickerField">
                  <label>End date</label>
                  <ReportButtonGroup
                    function={this.calendarFunction2}
                    dropDown={calendarReport2}
                    placeholder={this.state.dataPlaceholder2}
                    icon="fa-calendar"
                  />
                  {isDateRangeOverLimit && (
                    <p className="depot-field-error">{POI_ZONE_DATE_RANGE_MESSAGE}</p>
                  )}
                </div>
                <div className="inputElement reportPickerActions">
                  <Button
                    className={hasPendingReportChanges ? "reportPickerCreateButton report-create-pending" : "reportPickerCreateButton"}
                    variant="primary"
                    onClick={this.handleCreateReport}
                    size="sm"
                    disabled={!canCreateReport}
                  >
                    <i className="fa fa-map-marker"></i>
                    Create Report
                  </Button>
                </div>
              </div>
            </div>
            <TimeZoneConvert />
            {/* this.state.assetSelectionBoolean */}
            {this.state.assetSelectionBoolean ? (
              <div className="reportBody">
                {this.state.reportLoader ? (
                  <div className="loaderLine">
                    <br />{" "}
                    <GridLoader
                      size={7}
                      color={"#222222"}
                      loading={this.state.reportLoader}
                    />
                    <h1> &nbsp;Generating Report</h1>
                    <br />
                  </div>
                ) : this.state.errorLoader ? (
                  <div className="loaderLine">
                    <h1>Something Went Wrong...!</h1>
                  </div>
                ) : (
                  <React.Fragment>
                    <LocationTable pointData={this.state.reportDetails}
                      assetCustomerName = { this.state.assetCustomerName}
                      timeZone = {this.state.calendarStartDate}
                    />
                  </React.Fragment>
                )}
              </div>
            ) : (
              <AssetInforWarning />
            )}
          </div>
        </div>
        <Modal className="geofence-map-modal geofence-preview-modal" show={this.state.showPreviewModal} onHide={this.closePreviewModal} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.previewGeofence ? this.state.previewGeofence.name : "POI Zone Preview"}
              {this.state.previewGeofence && (
                <span className={this.state.previewGeofence.private ? "geofence-zone-badge private inline" : "geofence-zone-badge public inline"}>
                  {this.state.previewGeofence.private ? "Private" : "Public"}
                </span>
              )}
              {this.state.previewGeofence && this.state.previewGeofence.private && this.state.previewGeofence.ownerName && (
                <span className="geofence-zone-owner inline">{this.state.previewGeofence.ownerName}</span>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id="poiZoneVisitPreviewMap" className="geofence-preview-map"></div>
          </Modal.Body>
        </Modal>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
  timeZoneId: state.timeZoneId,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
};

export default connect(mapStateToProps, mapDispatchToProps)(PointOfInterest);
